import * as toolbox from 'components/common/toolbox';
import * as types from './action-types';
import firebase from 'firebase/compat/app';
import { toastr } from 'react-redux-toastr';

const firestore = firebase.firestore();
const _ = require('lodash');
const axios = require('axios');

/*-----------------------------------------------*/
/*  ATTACHMENTS
/*-----------------------------------------------*/

export function subAttachments(handle, id, source, prefix, field) {

	return dispatch => {

		dispatch({ type: prefix + '_' + field.toUpperCase() + '_CLEAR' });
		dispatch({ type: prefix + '_' + field.toUpperCase() + '_PENDING' });

		var unsubscribe = firestore.collection(`${handle}/${source}/${source}/${id}/${field}/`).doc(id).onSnapshot((doc) => {

			if (doc.exists) {
				var attachments = doc.data()[field] ?? [];
				dispatch({ type: prefix + '_' + field.toUpperCase() + '_FULFILLED', data: attachments, unsubscribe });
			} else {
				dispatch({ type: prefix + '_' + field.toUpperCase() + '_FULFILLED', data: [], unsubscribe });
			}
		});
	};
}
export function saveAttachment(handle, id, attachments, source, prefix, field, callback) {

	return async dispatch => {

		dispatch({ type: prefix + '_' + field.toUpperCase() + "_SAVE_PENDING" });

		const batch = firestore.batch();

		batch.set(firestore.collection(`${handle}/${source}/${source}/${id}/${field}`).doc(id), { [field]: attachments }, { merge: true });
		// Update serviceItems so it will reload with updated external invoices
		if (field == 'external_invoices') {
			batch.set(firestore.collection(`${handle}/${source}/${source}/${id}/serviceItems`).doc(id), { updated: new Date() }, { merge: true });
		}
		batch.commit().then(() => {
			window.toastr.success('The Attachment has been successfully saved/updated');
			dispatch({ type: prefix + '_' + field.toUpperCase() + '_SAVE_FULFILLED' });
			if (typeof callback === 'function') callback(id);
		}).catch((error) => {
			toolbox.process_error(error, 'Attachment NOT Saved');
		});
	};
}
export function attachmentSpinner(value) {

	return async dispatch => {
		dispatch({ type: types.ATTACHMENTS_SPINNER, data: value });
	};
}

/*-----------------------------------------------*/
/*  FUNCTIONS
/*-----------------------------------------------*/

export function prepUploadedImages(field, upload, record) {

	var myAttachment = { ...record };
	myAttachment.images = myAttachment.images ?? [];

	// Upload new image ------------------------------------------------

	if (Array.isArray(upload)) { 
		for (let image of upload) {
			let [field, imageUrl, path, type, dimensions] = image;
			let index = myAttachment.images?.length ?? 0;

			myAttachment.images[index] = { imageUrl, caption: '', type, dimensions }
			myAttachment[`imageUrl${index}`] = imageUrl;
			myAttachment[`imageUrl${index}_caption`] = '';
		}

	// Delete image ------------------------------------------------

	} else {
		let elementIndex = parseInt(field.split('imageUrl')[1]);
		for (let index = elementIndex; index < 10; index++) {
			if (myAttachment.images[(index + 1)]) {
				myAttachment.images[index] = myAttachment.images[(index + 1)] ?? null;
				myAttachment[`imageUrl${index}`] = myAttachment[`imageUrl${index + 1}`];
				myAttachment[`imageUrl${index}_caption`] = myAttachment[`imageUrl${index + 1}_caption`];
			} else {
				myAttachment.images.pop();
				delete myAttachment[`imageUrl${index}`];
				delete myAttachment[`imageUrl${index}_caption`];
				break
			}
		}
	}

	return myAttachment;
}